import AsyncStorage from '@react-native-async-storage/async-storage';
import { HostsModel, HostZonesModel } from '@w3lcome/types';
import AllowedHostsDB from '_/services/sqlite/AllowedHostsDB';
import UsersZonesDB from '_/services/sqlite/UsersZonesDB';
import { Platform } from 'react-native';
import { all, put, takeLatest } from 'redux-saga/effects';
import * as Effects from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import {
  getHostOfTheActualCompanyFailure,
  getHostOfTheActualCompanySuccess,
  getHostOfTheActualCompanyRequest,
  updateHostCardNumberSuccess,
  updateHostCardNumberFailure,
  updateHostCardNumberRequest,
  UPDATE_HOST_CARD_NUMBER_REQUEST,
} from './actions';
import hostsApi from '.././../../services/api/hosts';
import isInvenzi from '_/helpers/isInvenzi';
import { categoryAssignmentsApi, hostCardNumberspi } from '_/services/api';

const call: any = Effects.call;
export function* getHostOfTheActualCompany({
  payload,
}: ActionType<typeof getHostOfTheActualCompanyRequest>): Generator {
  const { companyId, userId } = payload;

  try {
    const [host]: HostsModel[] = yield call(hostsApi.getActualHost, {
      companyId,
      userId,
      includeZone: true,
    });

    if (!host?.id) {
      yield put(getHostOfTheActualCompanySuccess(null));
      return;
    }

    const [hostZones, { data: categoryAssignments }, hostCardNumbers] = yield all([
      call(hostsApi.getActualHostZones, { hostId: host.id }),
      call(categoryAssignmentsApi.getCategoryAssignments, {
        hostId: host.id,
        companyId: host.companyId,
      }),
      isInvenzi() ? call(hostCardNumberspi.findByHostId, host.id) : [],
    ]);

    const hostWithZones = {
      ...host,
      hostZones: hostZones ?? [],
      hostCardNumbers: hostCardNumbers ?? [],
      categoryAssignments: categoryAssignments ?? [],
      activeCategory: categoryAssignments?.[0] ?? null,
    };

    yield put(getHostOfTheActualCompanySuccess(hostWithZones));
  } catch (error) {
    yield put(getHostOfTheActualCompanyFailure());
  }
}

export function* updateHostCardNumber({
  payload,
}: ActionType<typeof updateHostCardNumberRequest>): Generator<any, void, any> {
  try {
    yield put(updateHostCardNumberSuccess(payload));
  } catch (error) {
    yield put(updateHostCardNumberFailure(error));
  }
}

export default all([
  takeLatest('@host/GET_HOST_OF_THE_ACTUAL_COMPANY_REQUEST', getHostOfTheActualCompany),
  takeLatest(UPDATE_HOST_CARD_NUMBER_REQUEST, updateHostCardNumber),
]);
